<template>
  <div id="arbitrate-order-detail">
    <el-dialog
      :top="
        ['admin', 'switchboard', 'credential_auditor', 'sms_admin'].indexOf(
          userInfo.userType
        ) !== -1
          ? '2vh'
          : '6vh'
      "
      width="1300px"
      center
      :close-on-click-modal="false"
      :visible="arbitrateOrderDetailObj.visible"
      @close="closeDialog"
    >
      <span slot="title">
        {{ arbitrateOrderDetailObj.type === "pay" ? "支付" : "提现" }}「{{
          arbitrateOrderDetailObj.platformOrder || ""
        }}」{{ arbitrationType === "arbitrate" ? "仲裁" : "回单" }}订单详情 (
        {{ arbitrateOrderDetailObj.id || "" }} )

        <template v-if="arbitrationType === 'arbitrate'">
          <el-tag
            v-if="arbitrateOrderDetailObj.arbitrationType === 1"
            size="small"
            >仲裁</el-tag
          >
          <el-tag
            v-else-if="arbitrateOrderDetailObj.arbitrationType === 2"
            type="danger"
            size="small"
            >查单仲裁</el-tag
          >
        </template>
      </span>

      <el-row>
        <el-col :span="24">
          <div class="order-status-layout">
            <div class="order-status-title">
              {{ arbitrationType === "arbitrate" ? "仲裁" : "回单" }}状态
            </div>
            <div
              class="order-status"
              v-html="
                HandleReceiptOrderStatusClass(
                  arbitrateOrderDetailObj.type,
                  arbitrateOrderDetailObj.status
                )
              "
            ></div>
            <el-button
              v-if="
                [
                  'admin',
                  'switchboard',
                  'credential_auditor',
                  'sms_admin',
                ].indexOf(userInfo.userType) !== -1
              "
              size="mini"
              style="position: absolute; right: 0; top: 0px"
              plain
              icon="el-icon-chicken"
              @click="
                commonCopyOrderDetailToClipboard(
                  arbitrateOrderDetailObj.type,
                  orderDetail
                );
                closeDialog();
              "
              >复制信息</el-button
            >
          </div> </el-col
        ><el-col
          :span="
            ['admin', 'switchboard', 'credential_auditor', 'sms_admin'].indexOf(
              userInfo.userType
            ) !== -1
              ? 18
              : 24
          "
        >
          <el-descriptions
            direction="vertical"
            border
            :column="
              orderDetail &&
              orderDetail.repayTime &&
              arbitrateOrderDetailObj.resultFotArbitrate.accType !== 'bank'
                ? 5
                : 6
            "
          >
            <el-descriptions-item label="平台订单号">
              {{ arbitrateOrderDetailObj.platformOrder }}
            </el-descriptions-item>
            <el-descriptions-item label="商户订单号">
              {{ arbitrateOrderDetailObj.appOrder }}
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">
              {{ orderDetail.createdTime || "-" }}
            </el-descriptions-item>
            <el-descriptions-item
              label="收款时间"
              v-if="arbitrateOrderDetailObj.type === 'pay'"
            >
              {{ orderDetail.payedTime || "-" }}
            </el-descriptions-item>
            <el-descriptions-item
              label="付款时间"
              v-else-if="arbitrateOrderDetailObj.type === 'withdraw'"
            >
              {{ orderDetail.withdrawedTime || "-" }}
            </el-descriptions-item>
            <el-descriptions-item
              v-if="orderDetail.repayTime"
              label="重复支付时间"
            >
              {{ orderDetail.repayTime }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="`${
                arbitrationType === 'arbitrate' ? '下单' : '回单'
              }金额`"
            >
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  arbitrateOrderDetailObj[
                    arbitrationType === "arbitrate" ? "freezeCost" : "billCost"
                  ],
                  2
                )
              }}
            </el-descriptions-item>
          </el-descriptions>
          <br />
          <el-descriptions
            direction="vertical"
            border
            v-loading="dataListLoading"
          >
            <el-descriptions-item>
              <template slot="label"
                >{{
                  arbitrationType === "arbitrate" ? "仲裁" : "回单"
                }}历程（左边最新）
                <i @click="getList()" class="el-icon-refresh cursorPointer" />
              </template>
              <el-steps>
                <el-step
                  v-for="(item, index) in dataList"
                  :key="index"
                  align-center
                  icon="el-icon-arrow-left"
                >
                  <template slot="title">
                    <div
                      v-if="arbitrationType"
                      @click="HandlePopMediaObj(index, item.mediaList)"
                      style="
                        font-size: 15px;
                        line-height: 28px;
                        cursor: pointer;
                      "
                    >
                      {{ item.createdTime || "-" }}
                      <br />
                      <el-tag
                        v-if="item.patchStatus === 9"
                        type="success"
                        size="medium"
                      >
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? patchStatusObj[arbitrationType].pay[
                                item.patchStatus
                              ]
                            : patchStatusObj[arbitrationType].withdraw[
                                item.patchStatus
                              ]
                        }}
                      </el-tag>
                      <el-tag
                        v-else-if="
                          [-3, -2, 10].indexOf(item.patchStatus) !== -1
                        "
                        type="danger"
                        size="medium"
                      >
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? patchStatusObj[arbitrationType].pay[
                                item.patchStatus
                              ]
                            : patchStatusObj[arbitrationType].withdraw[
                                item.patchStatus
                              ]
                        }}
                      </el-tag>
                      <el-tag
                        v-else-if="[-1].indexOf(item.patchStatus) !== -1"
                        size="medium"
                      >
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? patchStatusObj[arbitrationType].pay[
                                item.patchStatus
                              ]
                            : patchStatusObj[arbitrationType].withdraw[
                                item.patchStatus
                              ]
                        }}
                      </el-tag>
                      <el-tag v-else type="warning" size="medium">
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? patchStatusObj[arbitrationType].pay[
                                item.patchStatus
                              ]
                            : patchStatusObj[arbitrationType].withdraw[
                                item.patchStatus
                              ]
                        }}
                      </el-tag>
                      <br />
                      <!-- ============ Start 用户信息区块 ============ -->
                      <div style="margin-top: 2px">
                        <img :src="CoverEmojiByUserType(item.userType)" />
                        <div
                          style="
                            display: inline-block;
                            vertical-align: top;
                            height: 24px;
                            line-height: 24px;
                          "
                        >
                          <span
                            v-if="
                              ['customer'].indexOf(userInfo.userType) !== -1
                            "
                            >{{ translateUserType(item.userType) }}</span
                          >
                          <span v-else
                            >{{ item.relatedUserName
                            }}<span style="font-size: 12px"
                              >（{{ translateUserType(item.userType) }}）</span
                            ></span
                          >
                        </div>
                      </div>
                      <!-- ============ End 用户信息区块 ============ -->
                    </div>
                    <div>
                      <!-- ============ Start 文字部分 ============ -->
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.remark"
                        placement="bottom"
                        popper-class="arbitrate-remark-tooltip"
                      >
                        <el-button
                          v-if="item.remark"
                          @click="
                            HandleShowRemark(item.remark, item.relatedUserName)
                          "
                          style="vertical-align: top"
                          type="warning"
                          icon="el-icon-document"
                          size="mini"
                          >文字</el-button
                        >
                      </el-tooltip>
                      <!-- ============ End 文字部分 ============ -->

                      <!-- 凭证展示 -->
                      <el-row class="media-container">
                        <el-col
                          v-for="(mediaItem, mediaIndex) in item.mediaList"
                          :key="mediaItem + mediaIndex"
                          :span="12"
                          style="position: relative"
                        >
                          <!-- 网址另开窗口 -->
                          <el-tooltip
                            v-if="mediaItem.fileType === 'video'"
                            content="另开窗口显示"
                            placement="bottom"
                            effect="light"
                          >
                            <i
                              class="el-icon-copy-document window-open"
                              @click="
                                windowOpen(
                                  convertMedia(
                                    actionURL,
                                    arbitrateOrderDetailObj.orderId,
                                    item.mediaList[mediaIndex].url,
                                    'video',
                                    arbitrateOrderDetailObj.type
                                  )
                                )
                              "
                            />
                          </el-tooltip>
                          <!-- End 网址另开窗口 -->

                          <div
                            class="media-list-container cursorPointer"
                            @click="
                              HandleShowMedia(
                                item.mediaList,
                                mediaIndex,
                                mediaItem.fileType
                              )
                            "
                          >
                            <!-- 凭证类型图示 -->
                            <div class="media-type-list-container">
                              <span
                                v-for="(
                                  typeItem, typeIndex
                                ) in mediaItem.type.split(',')"
                                :key="typeItem + typeIndex"
                              >
                                <MediaType :type-item="typeItem" :isBg="true" />
                              </span>
                            </div>
                            <!-- End 凭证类型图示 -->
                            <div class="media-type-block-container">
                              <i
                                v-if="mediaItem.fileType === 'photo'"
                                class="el-icon-picture-outline media-type-block-icon photo"
                              />
                              <i
                                v-if="mediaItem.fileType === 'video'"
                                class="el-icon-video-play media-type-block-icon video"
                              />
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- End 凭证展示 -->
                    </div>
                  </template>
                </el-step>
              </el-steps>
            </el-descriptions-item>
          </el-descriptions>

          <!-- 凭证类型 -->
          <MediaType v-if="dataList.length > 0" />

          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="pageQuery.pageNum"
            :limit.sync="pageQuery.pageSize"
            :pageSizes="[5, 10, 20, 30, 50]"
            :autoScroll="false"
            @pagination="getList()"
          />

          <!-- ======================== Start 结案：确认出款 ======================== -->
          <div
            style="margin-top: -10px"
            v-if="
              ['admin', 'switchboard', 'credential_auditor'].indexOf(
                userInfo.userType
              ) !== -1 && arbitrateOrderDetailObj.status === 1
            "
          >
            <el-button
              style="margin: 2px 0"
              plain
              @click="HandleConfirmFinishCaseDialog(2)"
              size="small"
              type="primary"
              icon="el-icon-success"
            >
              {{
                arbitrateOrderDetailObj.type === "pay"
                  ? arbitrationType === "arbitrate"
                    ? "结案：仲裁收款成功"
                    : "结案：确认收款"
                  : arbitrationType === "arbitrate"
                  ? "结案：仲裁出款成功"
                  : "结案：确认出款"
              }}
            </el-button>

            <template v-if="arbitrateOrderDetailObj.type === 'pay'">
              <el-button
                style="margin: 2px 0"
                plain
                @click="HandleUploadDialog(4)"
                size="small"
                type="warning"
              >
                需商户再次提交凭证
              </el-button>
              <el-button
                style="margin: 2px 0"
                plain
                @click="HandleUploadDialog(5)"
                size="small"
                type="warning"
              >
                需卡主再次提交凭证
              </el-button>
              <el-button
                style="margin: 2px 0"
                plain
                @click="HandleUploadDialog(6)"
                size="small"
                type="warning"
              >
                需卡主与商户再次提交凭证
              </el-button>
            </template>

            <template v-if="arbitrateOrderDetailObj.type === 'withdraw'">
              <!-- 仲裁 -->
              <template v-if="arbitrationType === 'arbitrate'">
                <el-button
                  style="margin: 2px 0"
                  plain
                  @click="HandleUploadDialog(4)"
                  size="small"
                  type="warning"
                >
                  需商户再次提交凭证
                </el-button>
                <el-button
                  style="margin: 2px 0"
                  plain
                  @click="HandleUploadDialog(5)"
                  size="small"
                  type="warning"
                >
                  需卡主再次提交凭证
                </el-button>
                <el-button
                  style="margin: 2px 0"
                  plain
                  @click="HandleUploadDialog(6)"
                  size="small"
                  type="warning"
                >
                  需卡主与商户再次提交凭证
                </el-button>
              </template>
              <!-- End 仲裁 -->

              <!-- 回单 -->
              <template v-if="arbitrationType === 'receipt'">
                <el-popover placement="top-start" width="170" trigger="hover">
                  <el-button
                    v-for="(item, index) in arbitrateOptionBtn.receipt.withdraw"
                    :key="index"
                    style="margin: 2px 0"
                    plain
                    @click="HandleUploadDialog(item.value)"
                    size="small"
                    :type="item.type"
                    :icon="item.icon"
                  >
                    {{ item.label }}
                  </el-button>
                  <el-button
                    slot="reference"
                    style="margin: 2px 0"
                    plain
                    size="small"
                    icon="el-icon-question"
                    type="info"
                    round
                  >
                    需卡主再次提交
                  </el-button>
                </el-popover>
              </template>
              <!-- End 回单 -->
            </template>

            <el-button
              style="margin: 2px 0; float: right"
              plain
              @click="HandleConfirmFinishCaseDialog(3)"
              size="small"
              type="danger"
              icon="el-icon-error"
            >
              {{
                arbitrateOrderDetailObj.type === "pay"
                  ? arbitrationType === "arbitrate"
                    ? "结案：仲裁收款失败"
                    : "结案：确认未收款"
                  : arbitrationType === "arbitrate"
                  ? "结案：仲裁出款失败"
                  : "结案：确认未出款"
              }}
            </el-button>
            <el-button
              v-if="
                arbitrationType === 'arbitrate' &&
                arbitrateOrderDetailObj.specialType === 0 &&
                arbitrateOrderDetailObj.arbitratorRelatedStatus === 1 // 0 是等待回应中
              "
              style="margin: 2px 4px 2px 0; float: right"
              plain
              @click="HandleArbitrationSpecial()"
              size="small"
              type="danger"
              icon="el-icon-warning"
            >
              转至待结案
            </el-button>
            <!-- ======================== Start 出款结案：确认出款 ======================== -->
            <template v-if="arbitrationType === 'receipt'">
              <el-popover
                style="margin: 2px 4px 2px 0; float: right"
                v-if="['admin'].indexOf(userInfo.userType) !== -1"
                placement="top-start"
                width="232"
                trigger="hover"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="只有管理员手动删除暂扣才会返回积分"
                  placement="right"
                >
                  <el-button
                    plain
                    @click="HandleFreezeDialog(2, 2)"
                    size="small"
                    type="danger"
                    icon="el-icon-success"
                  >
                    结案：确认出款【永扣积分】
                  </el-button>
                </el-tooltip>
                <!-- ---------- 结案：暂扣 ---------- -->
                <el-tooltip
                  slot="reference"
                  class="item"
                  effect="dark"
                  content="超过指定时间没有查单会自动返还积分"
                  placement="right"
                >
                  <el-button
                    plain
                    @click="HandleFreezeDialog(2, 1)"
                    size="small"
                    type="warning"
                    icon="el-icon-success"
                  >
                    结案：确认出款【暂扣积分】
                  </el-button>
                </el-tooltip>
              </el-popover>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="超过指定时间没有查单会自动返还积分"
                placement="bottom"
              >
                <el-button
                  plain
                  @click="HandleFreezeDialog(2, 1)"
                  size="small"
                  type="warning"
                  icon="el-icon-success"
                >
                  结案：确认出款【暂扣积分】
                </el-button>
              </el-tooltip>
            </template>
            <!-- ======================== End 出款结案：确认出款 ======================== -->
          </div>

          <div
            v-if="
              [
                'admin',
                'switchboard',
                'credential_auditor',
                'sms_admin',
              ].indexOf(userInfo.userType) !== -1
            "
            style="margin-top: 6px"
          >
            <el-tabs
              type="border-card"
              v-model="orderActiveName"
              @tab-click="handleClick"
            >
              <el-tab-pane label="卡主银行卡收款订单(最近五)" name="payOrder">
                <!-- 订单 -->
                <div class="order-list table-container">
                  <el-table
                    border
                    stripe
                    ref="table"
                    v-loading="tableOrderLoading"
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    element-loading-spinner="el-icon-loading"
                    :data="dataPayOrderList"
                  >
                    <el-table-column width="210" label="平台订单号">
                      <template slot-scope="scope">
                        <el-popover
                          v-if="scope.row.createdUsername"
                          placement="top-start"
                          trigger="hover"
                        >
                          <span>
                            由 {{ scope.row.createdUsername }} 手动创建
                          </span>
                          <span slot="reference" type="primary">
                            <i
                              style="color: #409eff"
                              class="el-icon-user-solid"
                            ></i>
                          </span>
                        </el-popover>
                        {{ scope.row.orderId }}
                      </template>
                    </el-table-column>
                    <el-table-column width="80" label="下单金额">
                      <template slot-scope="scope">
                        {{
                          formatNumberWithCommasAndDecimalSeparator(
                            scope.row.originCost,
                            2
                          )
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="106"
                      prop="orderStatus"
                      label="订单状态"
                    >
                      <template slot-scope="scope">
                        <div
                          v-html="
                            HandleOrderStatusClass(scope.row.orderStatus, 'pay')
                          "
                        ></div>
                        <div
                          v-if="
                            userInfo &&
                            [
                              'admin',
                              'switchboard',
                              'seller',
                              'sms_admin',
                            ].indexOf(userInfo.userType) !== -1 &&
                            scope.row.refundStatus !== 0
                          "
                          v-html="
                            translateRefundStatusHTML(scope.row.refundStatus)
                          "
                        ></div>
                      </template>
                    </el-table-column>
                    <el-table-column width="87" label="补单状态">
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.supplementStatus"
                          size="small"
                          type="warning"
                        >
                          {{
                            HandleSupplementStatus(scope.row.supplementStatus)
                          }}
                        </el-tag>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="153" label="收款时间">
                      <template slot-scope="scope">
                        {{ scope.row.payedTime ? scope.row.payedTime : "-" }}
                      </template>
                    </el-table-column>
                    <el-table-column label="凭证">
                      <template slot-scope="scope">
                        <el-popover
                          placement="top-start"
                          width="350"
                          trigger="hover"
                        >
                          <div>
                            {{
                              scope.row.smsReceipt
                                ? `【短信】${scope.row.smsReceipt}`
                                : ""
                            }}
                            {{
                              scope.row.transdetailReceipt
                                ? `【银行流水】${scope.row.transdetailReceipt}`
                                : ""
                            }}
                          </div>
                          <div
                            class="read-more"
                            slot="reference"
                            type="primary"
                          >
                            {{
                              scope.row.smsReceipt
                                ? `【短信】${scope.row.smsReceipt}`
                                : ""
                            }}
                            {{
                              scope.row.transdetailReceipt
                                ? `【银行流水】${scope.row.transdetailReceipt}`
                                : ""
                            }}
                            {{
                              !scope.row.smsReceipt &&
                              !scope.row.transdetailReceipt
                                ? "-"
                                : ""
                            }}
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div></el-tab-pane
              >
              <el-tab-pane
                label="卡主银行卡出款订单(最近五)"
                name="withdrawOrder"
              >
                <div class="order-list table-container">
                  <el-table
                    border
                    stripe
                    ref="table"
                    v-loading="tableOrderLoading"
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    element-loading-spinner="el-icon-loading"
                    :data="dataWithdrawOrderList"
                  >
                    <el-table-column
                      width="210"
                      prop="orderId"
                      label="平台订单号"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.orderId }}
                      </template>
                    </el-table-column>

                    <el-table-column label="下单金额">
                      <template slot-scope="scope">
                        {{
                          formatNumberWithCommasAndDecimalSeparator(
                            scope.row.originCost,
                            2
                          )
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      width="106"
                      prop="orderStatus"
                      label="订单状态"
                    >
                      <template slot-scope="scope">
                        <div
                          v-html="
                            HandleOrderStatusClass(
                              scope.row.orderStatus,
                              'withdraw'
                            )
                          "
                        ></div>
                        <div
                          v-if="
                            userInfo &&
                            [
                              'admin',
                              'switchboard',
                              'seller',
                              'sms_admin',
                            ].indexOf(userInfo.userType) !== -1 &&
                            scope.row.refundStatus !== 0
                          "
                          v-html="
                            translateRefundStatusHTML(scope.row.refundStatus)
                          "
                        ></div>
                      </template>
                    </el-table-column>
                    <el-table-column width="87" label="补单状态">
                      <template slot-scope="scope">
                        <el-tag
                          v-if="scope.row.supplementStatus"
                          size="small"
                          type="warning"
                        >
                          {{
                            HandleSupplementStatus(scope.row.supplementStatus)
                          }}
                        </el-tag>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="153" label="付款时间">
                      <template slot-scope="scope">
                        {{
                          scope.row.withdrawedTime
                            ? scope.row.withdrawedTime
                            : "-"
                        }}
                      </template>
                    </el-table-column>

                    <el-table-column label="凭证">
                      <template slot-scope="scope">
                        <el-popover
                          v-if="
                            ['admin', 'switchboard', 'sms_admin'].indexOf(
                              userInfo.userType
                            ) !== -1
                          "
                          placement="top-start"
                          width="350"
                          trigger="hover"
                        >
                          <div>
                            {{
                              scope.row.smsReceipt
                                ? `【短信】${scope.row.smsReceipt}`
                                : ""
                            }}
                            {{
                              scope.row.transdetailReceipt
                                ? `【银行流水】${scope.row.transdetailReceipt}`
                                : ""
                            }}
                          </div>
                          <div
                            class="read-more"
                            slot="reference"
                            type="primary"
                          >
                            {{
                              scope.row.smsReceipt
                                ? `【短信】${scope.row.smsReceipt}`
                                : ""
                            }}
                            {{
                              scope.row.transdetailReceipt
                                ? `【银行流水】${scope.row.transdetailReceipt}`
                                : ""
                            }}
                            {{
                              !scope.row.smsReceipt &&
                              !scope.row.transdetailReceipt
                                ? "-"
                                : ""
                            }}
                          </div>
                        </el-popover>
                        <el-popover
                          v-if="
                            ['operator_admin'].indexOf(userInfo.userType) !== -1
                          "
                          placement="top-start"
                          width="350"
                          trigger="hover"
                        >
                          <div>
                            {{
                              scope.row.smsReceiptForWithdrawed
                                ? `【到账】${scope.row.smsReceiptForWithdrawed}`
                                : ""
                            }}
                          </div>
                          <div slot="reference" type="primary">
                            {{
                              scope.row.smsReceiptForWithdrawed
                                ? `【到账】${HandleReadMore(
                                    scope.row.smsReceiptForWithdrawed,
                                    15
                                  )}`
                                : ""
                            }}
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div></el-tab-pane
              >
            </el-tabs>
          </div> </el-col
        ><el-col
          :span="6"
          v-if="
            ['admin', 'switchboard', 'credential_auditor', 'sms_admin'].indexOf(
              userInfo.userType
            ) !== -1
          "
        >
          <!-- 显示出款、收款方信息 -->
          <div
            class="fixed-detail"
            v-if="arbitrateOrderDetailObj.resultFotArbitrate"
          >
            <div class="table-container" style="text-align: center; padding: 0">
              <el-table :show-header="false" :data="[1]">
                <el-table-column width="300px">
                  <ul class="wrap-card-info">
                    <li style="padding: 0">
                      <el-divider content-position="center">金额</el-divider>
                    </li>
                    <li style="padding: 0px">
                      <div
                        @click="
                          CopyTextToClipboard(
                            formatNumberWithCommasAndDecimalSeparator(
                              arbitrateOrderDetailObj.resultFotArbitrate
                                .billCost,
                              2
                            )
                          )
                        "
                        class="trans-money"
                        style="cursor: pointer"
                      >
                        ¥
                        {{
                          formatNumberWithCommasAndDecimalSeparator(
                            arbitrateOrderDetailObj.resultFotArbitrate.billCost,
                            2
                          )
                        }}
                        <i class="el-icon-document-copy" />
                      </div>
                    </li>

                    <!-- 收款方信息 -->
                    <li style="padding: 0">
                      <el-divider content-position="center"
                        >收款方信息</el-divider
                      >
                    </li>

                    <!-- Start 银行卡 -->
                    <li
                      v-if="
                        !arbitrateOrderDetailObj.resultFotArbitrate.accType ||
                        arbitrateOrderDetailObj.resultFotArbitrate.accType ===
                          'bank'
                      "
                      class="card to-card"
                    >
                      <span class="d">入</span>
                      <div class="bank-name">
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? arbitrateOrderDetailObj.resultFotArbitrate
                                .bankName
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .toBankName
                        }}({{
                          arbitrateOrderDetailObj.type === "pay"
                            ? arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCode
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .toBankCode
                        }})
                      </div>
                      <img
                        class="ic"
                        src="@/assets/images/ic.png"
                        alt=""
                      /><br />
                      <div class="bank-no">
                        <template
                          v-if="
                            !arbitrateOrderDetailObj.resultFotArbitrate
                              .accType ||
                            arbitrateOrderDetailObj.resultFotArbitrate
                              .accType === 'bank'
                          "
                        >
                          {{
                            arbitrateOrderDetailObj.type === "pay"
                              ? arbitrateOrderDetailObj.resultFotArbitrate.bankNo
                                  .match(/.{1,4}/g)
                                  .join(" ")
                              : arbitrateOrderDetailObj.resultFotArbitrate.toBankNo
                                  .match(/.{1,4}/g)
                                  .join(" ")
                          }}
                        </template>
                      </div>
                      <div
                        class="cursorPointer bank-card-name"
                        @click="
                          CopyTextToClipboard(
                            arbitrateOrderDetailObj.type === 'pay'
                              ? arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankCardName
                              : arbitrateOrderDetailObj.resultFotArbitrate
                                  .toRealName
                          )
                        "
                      >
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCardName
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .toRealName
                        }}
                        <i class="el-icon-document-copy" />
                      </div>
                      <img
                        class="union-pay"
                        style="width: 30px"
                        :src="
                          getBankLogo(
                            arbitrateOrderDetailObj.type === 'pay'
                              ? arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankCode
                              : arbitrateOrderDetailObj.resultFotArbitrate
                                  .toBankCode
                          )
                        "
                      />
                      <span class="two-ball">
                        <span></span>
                        <span></span>
                      </span>
                      <img
                        class="card__logo"
                        src="data:image/png;base64,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"
                      />
                    </li>
                    <!-- End 银行卡 -->

                    <!-- Start 二维码 -->
                    <li v-else>
                      支付模式：{{
                        arbitrateOrderDetailObj.resultFotArbitrate.accType ||
                        "-"
                      }}<br />
                      收款账号：{{
                        arbitrateOrderDetailObj.resultFotArbitrate
                          .collectionAccount || "-"
                      }}<br />
                      持有人实名：{{
                        arbitrateOrderDetailObj.resultFotArbitrate.realName ||
                        "-"
                      }}<br />
                      扫码类型：{{
                        arbitrateOrderDetailObj.resultFotArbitrate
                          .qrcodeType === 1
                          ? "好友邀请"
                          : "直接支付"
                      }}<br />
                      <template
                        v-if="
                          arbitrateOrderDetailObj.resultFotArbitrate
                            .qrcodeType === 1
                        "
                      >
                        好友支付验证码：{{
                          arbitrateOrderDetailObj.resultFotArbitrate
                            .inviteVerifyCode
                        }}
                      </template>
                    </li>
                    <!-- End 二维码 -->
                    <!-- End 收款方信息 -->

                    <!-- 出款方信息 -->
                    <template
                      v-if="
                        !arbitrateOrderDetailObj.resultFotArbitrate.accType ||
                        arbitrateOrderDetailObj.resultFotArbitrate.accType ===
                          'bank'
                      "
                    >
                      <li style="padding: 0">
                        <el-divider content-position="center"
                          >出款方信息</el-divider
                        >
                      </li>
                      <li class="card from-card">
                        <span class="d">出</span>
                        <div class="bank-name">
                          {{
                            arbitrateOrderDetailObj.type === "pay"
                              ? "-"
                              : arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankName +
                                "(" +
                                arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankCode +
                                ")"
                          }}
                        </div>
                        <img
                          class="ic"
                          src="@/assets/images/ic.png"
                          alt=""
                        /><br />
                        <div class="bank-no">
                          {{
                            arbitrateOrderDetailObj.type === "pay"
                              ? "---- ---- ---- ----"
                              : arbitrateOrderDetailObj.resultFotArbitrate.bankNo
                                  .match(/.{1,4}/g)
                                  .join(" ")
                          }}
                        </div>
                        <div class="bank-card-name">
                          {{
                            arbitrateOrderDetailObj.type === "pay"
                              ? realPayName
                              : arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankCardName
                          }}
                        </div>
                        <img
                          class="union-pay"
                          style="width: 30px"
                          :src="
                            getBankLogo(
                              arbitrateOrderDetailObj.type === 'pay'
                                ? ''
                                : arbitrateOrderDetailObj.resultFotArbitrate
                                    .bankCode
                            )
                          "
                        />
                        <span class="two-ball">
                          <span></span>
                          <span></span>
                        </span>
                        <img
                          class="card__logo"
                          src="data:image/png;base64,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"
                        />
                      </li>
                    </template>
                    <!-- End 出款方信息 -->

                    <template
                      v-if="dataDetail && Object.keys(dataDetail).length > 0"
                    >
                      <li style="padding: 0">
                        <el-divider content-position="center"
                          >近一个月汇总</el-divider
                        >
                      </li>
                      <li class="data-detail-list">
                        <el-tag>
                          总出款订单数：<span class="high-line">{{
                            formatNumberWithCommasAndDecimalSeparator(
                              dataDetail.totalWithdrawOrders,
                              2
                            )
                          }}</span>
                        </el-tag>
                        <el-tag>
                          成功出款数：<span class="high-line">{{
                            formatNumberWithCommasAndDecimalSeparator(
                              dataDetail.withdrawSuccessOrders,
                              2
                            )
                          }}</span>
                        </el-tag>
                        <el-tag>
                          成功金额：<span class="high-line">{{
                            formatNumberWithCommasAndDecimalSeparator(
                              dataDetail.withdrawSuccessAmount,
                              2
                            )
                          }}</span>
                        </el-tag>
                        <el-tag type="danger">
                          成功率：<span class="high-line">{{
                            formatNumberWithCommasAndDecimalSeparator(
                              dataDetail.withdrawSuccessRate,
                              2
                            )
                          }}</span>
                          %
                        </el-tag>
                      </li>
                    </template>

                    <!-- 近一个月汇总 -->
                    <template v-if="arbitrateOrderDetailObj.type !== 'pay'">
                      <li style="padding: 0">
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="click"
                          title="可能来源号码"
                          v-if="fromPhoneList && fromPhoneList.length > 0"
                        >
                          <ul
                            style="
                              padding: 0 5px;
                              list-style: none;
                              margin: 0px;
                              font-size: 14px;
                            "
                          >
                            <li
                              style="margin-bottom: 6px"
                              v-for="(item, index) in fromPhoneList"
                              :key="index"
                            >
                              {{ item }}
                            </li>
                          </ul>
                          <el-badge
                            slot="reference"
                            style="
                              position: absolute;
                              left: 0;
                              top: -12px;
                              z-index: 100;
                              background-color: #fff;
                            "
                            :value="fromPhoneList.length"
                          >
                            <el-button
                              icon="el-icon-phone-outline"
                              size="mini"
                            />
                          </el-badge>
                        </el-popover>
                        <el-button
                          v-else
                          style="
                            position: absolute;
                            left: 0;
                            top: -12px;
                            z-index: 100;
                            background-color: #fff;
                          "
                          :disabled="true"
                          icon="el-icon-phone"
                          size="mini"
                        />
                        <el-popover
                          placement="top"
                          trigger="hover"
                          v-if="
                            [
                              'admin',
                              'credential_auditor',
                              'sms_admin',
                            ].indexOf(userInfo.userType) !== -1
                          "
                        >
                          <span>卡主全部上传短信</span>
                          <el-button
                            slot="reference"
                            style="
                              position: absolute;
                              right: 0;
                              top: -12px;
                              z-index: 100;
                              background-color: #fff;
                            "
                            @click="HandleSmsHistoryDialog()"
                            icon="el-icon-chat-line-square"
                            size="mini"
                          />
                        </el-popover>
                      </li>
                      <li style="padding: 0">
                        <el-divider content-position="center"
                          ><i class="el-icon-bell"></i> 附言</el-divider
                        >
                        <div style="text-align: center">
                          {{ orderDetail.message || "-" }}
                        </div>
                      </li>
                      <li style="padding: 0">
                        <el-divider content-position="center"
                          >辅助决策凭证</el-divider
                        >
                      </li>
                      <li
                        style="border: 1px solid #d8d8d8; border-radius: 10px"
                      >
                        <span>
                          {{
                            orderDetail.referenceSmsReceipt
                              ? `${orderDetail.referenceSmsReceipt}`
                              : ""
                          }}
                        </span>

                        <div
                          class="cursorPointer"
                          style="text-align: center; color: #409eff"
                          :style="
                            orderDetail.referenceSmsReceipt
                              ? 'margin-top: 10px'
                              : ''
                          "
                          @click="getWithdrawOrderDetailList(true)"
                        >
                          <i class="el-icon-refresh-left" /> 刷新
                        </div>
                      </li>
                    </template>
                    <!-- End 近一个月汇总 -->
                  </ul>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
      <SmsHistoryDialog :smsHistoryDialogObj.sync="smsHistoryDialogObj" />
    </el-dialog>

    <!-- 提交凭证内容 -->
    <el-dialog
      top="20vh"
      width="1000px"
      center
      :close-on-click-modal="false"
      :title="
        dataList[popMediaObj.index]
          ? ['customer'].indexOf(userInfo.userType) !== -1
            ? `${translateUserType(
                dataList[popMediaObj.index].userType
              )} 提交凭证内容`
            : `${
                dataList[popMediaObj.index].relatedUserName
              } ${translateUserType(
                dataList[popMediaObj.index].userType
              )} 提交凭证内容`
          : ''
      "
      :visible="popMediaObj.visible"
      @close="closePopMediaDialog()"
    >
      <el-carousel
        type="card"
        height="400px"
        :autoplay="false"
        :loop="false"
        trigger="click"
      >
        <el-carousel-item
          v-if="
            dataList[popMediaObj.index] && dataList[popMediaObj.index].remark
          "
        >
          <h3>
            {{ dataList[popMediaObj.index].remark }}
          </h3>
        </el-carousel-item>
        <el-carousel-item
          v-for="(mediaItem, mediaIndex) in popMediaObj.mediaList"
          :key="mediaItem.url + mediaIndex"
        >
          <!-- 凭证类型图示 -->
          <div class="media-type-show-layout">
            <span
              v-for="(typeItem, typeIndex) in mediaItem.type.split(',')"
              :key="typeItem + typeIndex"
            >
              <MediaType :type-item="typeItem" iconSize="25" />
            </span>
          </div>
          <!-- End 凭证类型图示 -->

          <!-- 图片凭证 -->
          <img
            v-if="mediaItem.fileType === 'photo'"
            style="width: 100%"
            :src="
              convertMedia(
                actionURL,
                arbitrateOrderDetailObj.orderId,
                mediaItem.url,
                'image',
                arbitrateOrderDetailObj.type
              )
            "
          />
          <!-- End 图片凭证 -->

          <!-- 视频凭证 -->
          <template v-if="mediaItem.fileType === 'video'">
            <video
              width="100%"
              height="100%"
              controls
              :src="
                convertMedia(
                  actionURL,
                  arbitrateOrderDetailObj.orderId,
                  mediaItem.url,
                  'video',
                  arbitrateOrderDetailObj.type
                )
              "
            ></video>
          </template>
          <!-- End 视频凭证 -->
        </el-carousel-item>
      </el-carousel>

      <!-- 凭证类型 -->
      <MediaType />
    </el-dialog>
    <!-- End 提交凭证内容 -->

    <!-- 凭证展示弹框 -->
    <span id="zIndexObj-1">
      <el-dialog
        :top="showMediaObj.type === 'remark' ? '30vh' : '2vh'"
        :width="showMediaObj.type === 'remark' ? '500px' : '65%'"
        center
        :close-on-click-modal="false"
        :visible="showMediaObj.visible"
        :title="
          showMediaObj.list &&
          showMediaObj.list[showMediaObj.index] &&
          showMediaObj.list[showMediaObj.index].type
            ? getMediaTypeLabels(showMediaObj.list[showMediaObj.index].type) +
              '凭证'
            : ''
        "
        @close="closeShowMediaDialog()"
      >
        <!-- 凭证类型图示 -->
        <div
          class="media-type-show-layout"
          v-if="showMediaObj.list && showMediaObj.list[showMediaObj.index]"
        >
          <span
            v-for="(typeItem, typeIndex) in showMediaObj.list[
              showMediaObj.index
            ].type.split(',')"
            :key="typeItem + typeIndex"
          >
            <MediaType :type-item="typeItem" iconSize="25" />
          </span>
        </div>
        <!-- End 凭证类型图示 -->

        <!-- 图片凭证 -->
        <div
          v-if="
            showMediaObj.type === 'photo' &&
            showMediaObj.list &&
            showMediaObj.list[showMediaObj.index] &&
            (showMediaObj.list[showMediaObj.index].url ||
              showMediaObj.list[showMediaObj.index].externalUrl)
          "
          style="text-align: center"
        >
          <img
            v-if="showMediaObj.list[showMediaObj.index].url"
            @click="
              windowOpen(
                convertMedia(
                  actionURL,
                  arbitrateOrderDetailObj.orderId,
                  showMediaObj.list[showMediaObj.index].url,
                  'image',
                  arbitrateOrderDetailObj.type
                )
              )
            "
            style="height: 82vh; cursor: pointer"
            :src="
              convertMedia(
                actionURL,
                arbitrateOrderDetailObj.orderId,
                showMediaObj.list[showMediaObj.index].url,
                'image',
                arbitrateOrderDetailObj.type
              )
            "
          />
          <img
            v-else-if="showMediaObj.list[showMediaObj.index].externalUrl"
            @click="
              windowOpen(showMediaObj.list[showMediaObj.index].externalUrl)
            "
            style="cursor: pointer"
            :src="showMediaObj.list[showMediaObj.index].externalUrl"
          />
        </div>
        <!-- End 图片凭证 -->

        <!-- 视频凭证 -->
        <template
          v-if="
            showMediaObj.type === 'video' &&
            showMediaObj.list &&
            showMediaObj.list[showMediaObj.index] &&
            showMediaObj.list[showMediaObj.index].url
          "
        >
          <div style="text-align: center">
            <video-player
              :options="{
                muted: true,
                autoplay: false,
                controls: true,
                type: 'video/mp4',
                sources: [
                  {
                    type: 'video/mp4',
                    src: convertMedia(
                      actionURL,
                      arbitrateOrderDetailObj.orderId,
                      showMediaObj.list[showMediaObj.index].url,
                      'video',
                      arbitrateOrderDetailObj.type
                    ),
                  },
                ],
              }"
            />
          </div>

          <div style="text-align: right">
            <!-- 网址另开窗口 -->
            <el-button
              @click="
                windowOpen(
                  convertMedia(
                    actionURL,
                    arbitrateOrderDetailObj.orderId,
                    showMediaObj.list[showMediaObj.index].url,
                    'video',
                    arbitrateOrderDetailObj.type
                  )
                )
              "
              style="margin-top: 10px"
              size="small"
              icon="el-icon-copy-document"
            ></el-button>
            <!-- End 网址另开窗口 -->

            <!-- 旋转视频 -->
            <el-button
              @click="HandleRotateVideo()"
              style="margin-top: 10px"
              size="small"
              type="danger"
              icon="el-icon-refresh-right"
            ></el-button>
            <!-- End 旋转视频 -->
          </div>
        </template>
        <!-- End 视频凭证 -->
      </el-dialog>
      <!-- End 凭证展示弹框 -->
    </span>

    <span id="zIndexObj-2">
      <!-- 支付未到帐审核 -->
      <NeedReviewOrder
        :need-review-order-obj="needReviewOrderObj"
        v-if="
          (['admin', 'credential_auditor'].indexOf(userInfo.userType) !== -1 ||
            userInfo.roles.indexOf('zhuli') !== -1) &&
          showMediaObj.visible
        "
      />
    </span>
    <!-- End 支付未到帐审核 -->

    <!-- 显示出款、收款方信息 弹框给视频用以对照 -->
    <span id="zIndexObj-3">
      <template
        v-if="
          ['admin', 'switchboard', 'credential_auditor', 'sms_admin'].indexOf(
            userInfo.userType
          ) !== -1 && showBankInfoDialog
        "
      >
        <div
          class="fixed-detail fixed-detail-dialog"
          v-if="showFixedBankInfo && arbitrateOrderDetailObj.resultFotArbitrate"
        >
          <i
            @click="showFixedBankInfo = false"
            style="cursor: pointer; float: right; margin-right: 6px"
            class="el-icon-minus"
          />
          <div class="table-container" style="text-align: center; padding: 0">
            <el-table :show-header="false" :data="[1]">
              <el-table-column width="300px">
                <ul class="wrap-card-info">
                  <li style="padding: 0">
                    <el-divider content-position="center">金额</el-divider>
                  </li>
                  <li style="padding: 0px">
                    <div
                      @click="
                        CopyTextToClipboard(
                          formatNumberWithCommasAndDecimalSeparator(
                            arbitrateOrderDetailObj.resultFotArbitrate.billCost,
                            2
                          )
                        )
                      "
                      class="trans-money"
                      style="cursor: pointer"
                    >
                      ¥
                      {{
                        formatNumberWithCommasAndDecimalSeparator(
                          arbitrateOrderDetailObj.resultFotArbitrate.billCost,
                          2
                        )
                      }}
                      <i class="el-icon-document-copy" />
                    </div>
                  </li>

                  <!-- 收款方信息 -->
                  <li style="padding: 0">
                    <el-divider content-position="center"
                      >收款方信息</el-divider
                    >
                  </li>

                  <!-- Start 银行卡 -->
                  <li
                    v-if="
                      !arbitrateOrderDetailObj.resultFotArbitrate.accType ||
                      arbitrateOrderDetailObj.resultFotArbitrate.accType ===
                        'bank'
                    "
                    class="card to-card"
                  >
                    <span class="d">入</span>
                    <div class="bank-name">
                      {{
                        arbitrateOrderDetailObj.type === "pay"
                          ? arbitrateOrderDetailObj.resultFotArbitrate.bankName
                          : arbitrateOrderDetailObj.resultFotArbitrate
                              .toBankName
                      }}({{
                        arbitrateOrderDetailObj.type === "pay"
                          ? arbitrateOrderDetailObj.resultFotArbitrate.bankCode
                          : arbitrateOrderDetailObj.resultFotArbitrate
                              .toBankCode
                      }})
                    </div>
                    <img class="ic" src="@/assets/images/ic.png" alt="" /><br />
                    <div class="bank-no">
                      {{
                        arbitrateOrderDetailObj.type === "pay"
                          ? arbitrateOrderDetailObj.resultFotArbitrate.bankNo
                              .match(/.{1,4}/g)
                              .join(" ")
                          : arbitrateOrderDetailObj.resultFotArbitrate.toBankNo
                              .match(/.{1,4}/g)
                              .join(" ")
                      }}
                    </div>
                    <div
                      class="cursorPointer bank-card-name"
                      @click="
                        CopyTextToClipboard(
                          arbitrateOrderDetailObj.type === 'pay'
                            ? arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCardName
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .toRealName
                        )
                      "
                    >
                      {{
                        arbitrateOrderDetailObj.type === "pay"
                          ? arbitrateOrderDetailObj.resultFotArbitrate
                              .bankCardName
                          : arbitrateOrderDetailObj.resultFotArbitrate
                              .toRealName
                      }}
                      <i class="el-icon-document-copy" />
                    </div>
                    <img
                      class="union-pay"
                      style="width: 30px"
                      :src="
                        getBankLogo(
                          arbitrateOrderDetailObj.type === 'pay'
                            ? arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCode
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .toBankCode
                        )
                      "
                    />
                    <span class="two-ball">
                      <span></span>
                      <span></span>
                    </span>
                    <img
                      class="card__logo"
                      src="data:image/png;base64,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"
                    />
                  </li>
                  <!-- End 银行卡 -->

                  <!-- Start 二维码 -->
                  <li v-else>
                    支付模式：{{
                      arbitrateOrderDetailObj.resultFotArbitrate.accType || "-"
                    }}<br />
                    收款账号：{{
                      arbitrateOrderDetailObj.resultFotArbitrate
                        .collectionAccount || "-"
                    }}<br />
                    持有人实名：{{
                      arbitrateOrderDetailObj.resultFotArbitrate.realName ||
                      "-"
                    }}<br />
                    扫码类型：{{
                      arbitrateOrderDetailObj.resultFotArbitrate.qrcodeType ===
                      1
                        ? "好友邀请"
                        : "直接支付"
                    }}<br />
                    <template
                      v-if="
                        arbitrateOrderDetailObj.resultFotArbitrate
                          .qrcodeType === 1
                      "
                    >
                      好友支付验证码：{{
                        arbitrateOrderDetailObj.resultFotArbitrate
                          .inviteVerifyCode
                      }}
                    </template>
                  </li>
                  <!-- End 二维码 -->
                  <!-- End 收款方信息 -->

                  <!-- 出款方信息 -->
                  <template
                    v-if="
                      !arbitrateOrderDetailObj.resultFotArbitrate.accType ||
                      arbitrateOrderDetailObj.resultFotArbitrate.accType ===
                        'bank'
                    "
                  >
                    <li style="padding: 0">
                      <el-divider content-position="center"
                        >出款方信息</el-divider
                      >
                    </li>
                    <li class="card from-card">
                      <span class="d">出</span>
                      <div class="bank-name">
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? "-"
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .bankName +
                              "(" +
                              arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCode +
                              ")"
                        }}
                      </div>
                      <img
                        class="ic"
                        src="@/assets/images/ic.png"
                        alt=""
                      /><br />
                      <div class="bank-no">
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? "---- ---- ---- ----"
                            : arbitrateOrderDetailObj.resultFotArbitrate.bankNo
                                .match(/.{1,4}/g)
                                .join(" ")
                        }}
                      </div>
                      <div class="bank-card-name">
                        {{
                          arbitrateOrderDetailObj.type === "pay"
                            ? realPayName
                            : arbitrateOrderDetailObj.resultFotArbitrate
                                .bankCardName
                        }}
                      </div>
                      <img
                        class="union-pay"
                        style="width: 30px"
                        :src="
                          getBankLogo(
                            arbitrateOrderDetailObj.type === 'pay'
                              ? ''
                              : arbitrateOrderDetailObj.resultFotArbitrate
                                  .bankCode
                          )
                        "
                      />
                      <span class="two-ball">
                        <span></span>
                        <span></span>
                      </span>
                      <img
                        class="card__logo"
                        src="data:image/png;base64,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"
                      />
                    </li>
                  </template>
                  <!-- End 出款方信息 -->

                  <template
                    v-if="dataDetail && Object.keys(dataDetail).length > 0"
                  >
                    <li style="padding: 0">
                      <el-divider content-position="center"
                        >近一个月汇总</el-divider
                      >
                    </li>
                    <li class="data-detail-list">
                      <el-tag>
                        总出款订单数：<span class="high-line">{{
                          formatNumberWithCommasAndDecimalSeparator(
                            dataDetail.totalWithdrawOrders,
                            2
                          )
                        }}</span>
                      </el-tag>
                      <el-tag>
                        成功出款数：<span class="high-line">{{
                          formatNumberWithCommasAndDecimalSeparator(
                            dataDetail.withdrawSuccessOrders,
                            2
                          )
                        }}</span>
                      </el-tag>
                      <el-tag>
                        成功金额：<span class="high-line">{{
                          formatNumberWithCommasAndDecimalSeparator(
                            dataDetail.withdrawSuccessAmount,
                            2
                          )
                        }}</span>
                      </el-tag>
                      <el-tag type="danger">
                        成功率：<span class="high-line">{{
                          formatNumberWithCommasAndDecimalSeparator(
                            dataDetail.withdrawSuccessRate,
                            2
                          )
                        }}</span>
                        %
                      </el-tag>
                    </li>
                  </template>

                  <template v-if="arbitrateOrderDetailObj.type !== 'pay'">
                    <li style="padding: 0">
                      <el-divider content-position="center"
                        ><i class="el-icon-bell"></i> 附言</el-divider
                      >
                      <div style="text-align: center">
                        {{ orderDetail.message || "-" }}
                      </div>
                    </li>
                    <li style="padding: 0">
                      <el-divider content-position="center"
                        >辅助决策凭证</el-divider
                      >
                    </li>
                    <li style="border: 1px solid #d8d8d8; border-radius: 10px">
                      <span>
                        {{
                          orderDetail.referenceSmsReceipt
                            ? `${orderDetail.referenceSmsReceipt}`
                            : ""
                        }}
                      </span>

                      <div
                        class="cursorPointer"
                        style="text-align: center; color: #409eff"
                        :style="
                          orderDetail.referenceSmsReceipt
                            ? 'margin-top: 10px'
                            : ''
                        "
                        @click="getWithdrawOrderDetailList(true)"
                      >
                        <i class="el-icon-refresh-left" /> 刷新
                      </div>
                    </li>
                  </template>
                </ul>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          v-if="
            !showFixedBankInfo && arbitrateOrderDetailObj.resultFotArbitrate
          "
          class="fixed-detail fixed-detail-dialog"
          style="padding: 6px"
        >
          <i
            @click="showFixedBankInfo = true"
            style="cursor: pointer; font-size: 24px; float: right"
            class="el-icon-bank-card"
          />
        </div>
      </template>
    </span>

    <!-- 暂扣确认弹框 -->
    <el-dialog
      class="freeze-dialog"
      top="30vh"
      width="560px"
      center
      :visible="freezeObj.visible"
      @close="HandleFreezeDialogClose()"
    >
      <template v-if="freezeObj.freezeAmountTimeType === 1">
        <i
          class="el-alert__icon el-icon-warning is-big"
          style="color: #e6a23c; float: left; width: 40px"
        ></i>
        <strong style="line-height: 26px; font-size: 18px"
          >结案，确认出款<span style="color: #e6a23c">【暂扣积分】</span
          ><br />超过指定时间没有查单会自动返还积分</strong
        >
      </template>
      <template v-else-if="freezeObj.freezeAmountTimeType === 2">
        <i
          class="el-alert__icon el-icon-error is-big"
          style="color: #f56c6c; float: left; width: 40px"
        ></i>
        <strong style="line-height: 26px; font-size: 18px"
          >结案，确认出款<span style="color: #f56c6c">【永扣积分】</span
          ><br />只有管理员手动删除暂扣才会返回积分</strong
        >
      </template>

      <el-radio-group
        v-if="freezeObj.freezeAmountTimeType === 1"
        class="freeze-option"
        v-model="freezeObjOption"
        @change="freezeObjOptionChange()"
      >
        <el-radio :label="1">没有录制出款过程的视频</el-radio>
        <el-radio :label="2"
          >没有订单出款短信（补充提交短信视频给代理或者客服可以解除暂扣）</el-radio
        >
        <el-radio :label="3"
          >其他
          <el-input
            ref="remark1"
            v-show="freezeObjOption === 3"
            placeholder="备注可让卡主查阅暂扣原因"
            size="mini"
            clearable
            v-model.trim="freezeObj.remark"
        /></el-radio>
      </el-radio-group>
      <el-input
        ref="remark2"
        style="margin-top: 30px"
        v-else-if="freezeObj.freezeAmountTimeType === 2"
        placeholder="备注可让卡主查阅永扣原因"
        size="mini"
        clearable
        v-model.trim="freezeObj.remark"
      />

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleFreezeDialogClose()">
          取消
        </el-button>
        <el-button
          size="mini"
          type="success"
          :loading="freezeObj.loading"
          @click="HandleFreezeDialogSubmit()"
        >
          提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 确认弹框 -->
    <el-dialog
      class="freeze-dialog"
      top="30vh"
      width="560px"
      center
      :visible="finishCaseObj.visible"
      @close="HandleConfirmFinishCaseDialogClose()"
    >
      <template v-if="finishCaseObj.status === 2">
        <i
          class="el-alert__icon el-icon-success is-big"
          style="color: #409eff; float: left; width: 40px"
        ></i>
        <strong style="line-height: 26px; font-size: 18px"
          >{{
            arbitrationType === "arbitrate" ? `"仲裁"` : `"回单"`
          }}
          确认结案，并且实际已{{
            this.arbitrateOrderDetailObj.type === "pay" ? "收" : "出"
          }}款？</strong
        >
      </template>
      <template v-if="finishCaseObj.status === 3">
        <i
          class="el-alert__icon el-icon-error is-big"
          style="color: #f56c6c; float: left; width: 40px"
        ></i>
        <strong style="line-height: 26px; font-size: 18px"
          ><span class="warning-title"> 警告！ 警告！ 警告！ </span><br />
          <span class="warning-content">
            {{ arbitrationType === "arbitrate" ? `"仲裁"` : `"回单"` }}
            请认真确认是否未打款，以免造成金钱损失。
          </span></strong
        >
      </template>
      <el-input
        v-show="
          !(arbitrationType !== 'arbitrate' && finishCaseObj.status === 2) // 回单并且是确认的情况会给默认原因，不需填
        "
        ref="finishRemark"
        style="margin-top: 30px"
        placeholder="请说明作出此结论的原因或理由！"
        size="small"
        clearable
        v-model.trim="finishCaseObj.remark"
      />

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleConfirmFinishCaseDialogClose()">
          取消
        </el-button>
        <el-button
          size="mini"
          type="success"
          :loading="finishCaseObj.loading"
          @click="HandleConfirmFinishCase()"
        >
          提交
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import VideoPlayer from "@/components/VideoPlayer.vue";
import Pagination from "@/views/components/Pagination";
import SmsHistoryDialog from "@/views/components/dialog/SmsHistoryDialog.vue";
import MediaType from "@/views/components/MediaType";
import NeedReviewOrder from "@/views/components/NeedReviewOrder";
import {
  arbitrateDetail,
  arbitrateFinishCase,
  arbitrateWithdrawDetail,
  arbitrateWithdrawFinishCase,
  getPayOrderDetailList, // 获取支付订单详情列表
  getWithdrawOrderDetailList, // 获取提现订单详情列表
  getPayOrderListNoPage, // 获取不分页支付订单列表
  getWithdrawOrderListNoPage, // 获取不分页提现订单列表
  updatePayToSpecialType, // 支付仲裁更新特殊类型
  updateWithdrawToSpecialType, // 提现仲裁更新特殊类型
  getCodePayOrderList, // 获取二维码订单列表
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["arbitrateOrderDetailObj"],
  components: {
    MediaType,
    VideoPlayer,
    Pagination,
    SmsHistoryDialog,
    NeedReviewOrder,
  },
  watch: {
    // 监听仲裁 obj
    arbitrateUploadObj: {
      deep: true,
      handler() {
        this.dataListLoading = true;
        if (this.arbitrateOrderDetailObj.id) {
          setTimeout(() => {
            this.getList();
          }, 1000);
        }
        this.arbitrateUploadObj.uploading = false;
      },
    },
    arbitrateOrderDetailObj(val) {
      if (val.visible) {
        this.getList();
        if (
          ["admin", "switchboard", "credential_auditor", "sms_admin"].indexOf(
            this.userInfo.userType
          ) !== -1
        ) {
          this.HandleDateDefault();
          this.orderActiveName = "withdrawOrder";
          this.HandleGetOrderList("withdraw");
        }

        // 取得订单资讯，提供给「复制信息」使用
        if (val.type === "pay") {
          if (
            !this.arbitrateOrderDetailObj.resultFotArbitrate.accType ||
            this.arbitrateOrderDetailObj.resultFotArbitrate.accType === "bank"
          ) {
            this.getPayOrderDetailList();
          } else {
            this.getCodePayOrderList();
          }
        } else if (val.type === "withdraw") {
          this.getWithdrawOrderDetailList();
        }

        // 判断类型 0: 回单, 1: 仲裁, 2: 查单仲裁
        this.arbitrationType =
          val.arbitrationType === 0 ? "receipt" : "arbitrate";
      }
    },
  },
  data() {
    return {
      orderDetail: {}, // 订单详情
      arbitrationType: null, // 回单 或 仲裁详情
      mediaTypeOptions: varCommon.mediaTypeOptions, // 凭证类型
      actionURL: `${process.env.BASE_API.replace("api2/", "")}media/file`,
      popMediaObj: {
        visible: false,
        index: null,
        mediaList: [],
      },
      showMediaObj: {
        visible: false,
        index: null,
        type: null,
        list: [],
      },
      customerOption: null, // 卡主申诉选项
      adminOption: null, // 仲裁管理员结案选项
      total: 0,
      pageQuery: {
        id: null,
        pageSize: 5,
        pageNum: 1,
      },
      dataListLoading: false,
      dataList: [],
      dataDetail: {},
      fromPhoneList: [],
      patchStatusObj: varCommon.patchStatusObj,
      showBankInfoDialog: false,
      showFixedBankInfo: true,
      transformRotate: 0,
      /* 历史订单 */
      dataPayOrderList: [],
      dataWithdrawOrderList: [],
      tableOrderLoading: false,
      pageOrderQuery: {},
      supplementStatusOptions: [
        { label: "全部补单状态", value: null },
        { label: "支付补单", value: 1 },
        { label: "提现补单", value: 2 },
        { label: "重复支付补单", value: 3 },
        { label: "强行完成", value: 4 },
        { label: "强行完成", value: 5 },
        { label: "卡主确认", value: 6 },
        { label: "命令补单", value: 7 },
        { label: "命令补单", value: 8 },
        { label: "客服确认支付", value: 9 },
      ],
      orderActiveName: "withdrawOrder",
      logOrderActiveName: "withdrawOrder", // 防止重复点击
      smsHistoryDialogObj: {
        visible: false,
        username: "",
        userId: "",
      },
      /* 按钮 */
      arbitrateOptionBtn: {
        receipt: {
          withdraw: [
            {
              label: "打款视频",
              type: "primary",
              icon: "el-icon-money",
              value: 51,
            },
            {
              label: "账单视频",
              type: "success",
              icon: "el-icon-notebook-2",
              value: 52,
            },
            {
              label: "打款与账单视频",
              type: "danger",
              icon: "el-icon-connection",
              value: 53,
            },
            {
              label: "其他凭证",
              type: "warning",
              icon: "el-icon-folder-opened",
              value: 54,
            },
          ],
        },
      },
      /* 暂扣选项 */
      freezeObjOption: null,
      /* 暫扣積分 */
      freezeObj: {
        visible: false,
        loading: false,
        arbitrationApplyId: null,
        status: null,
        freezeAmountTimeType: null,
        remark: null,
      },
      // 结案弹框
      finishCaseObj: {
        visible: false,
        loading: false,
        arbitrationApplyId: null,
        status: null,
        remark: null,
      },
      needReviewOrderObj: null, // 审核支付单数据
    };
  },
  computed: {
    realPayName() {
      if (this.arbitrateOrderDetailObj.resultFotArbitrate.transPayName) {
        return (
          "付款人姓名：" +
          this.arbitrateOrderDetailObj.resultFotArbitrate.transPayName
        );
      } else if (
        this.arbitrateOrderDetailObj.resultFotArbitrate.tempPayerName
      ) {
        return (
          "暂存付款人：" +
          this.arbitrateOrderDetailObj.resultFotArbitrate.tempPayerName
        );
      } else {
        return "-";
      }
    },
    // 仲裁 obj
    arbitrateUploadObj: {
      get() {
        return this.$store.state.app.arbitrateUploadObj;
      },
      set(val) {
        this.$store.commit("SET_ARBITRATE_UPLOAD_OBJ", val);
      },
    },
  },
  mounted() {
    let inElement = document.querySelector(
      "#arbitrate-order-detail #zIndexObj-1 .el-dialog"
    );
    let outElement = document.querySelector(
      "#arbitrate-order-detail #zIndexObj-1"
    );

    inElement.addEventListener("mouseenter", function () {
      outElement.style.zIndex = "99999";
    });
    inElement.addEventListener("mouseleave", function () {
      outElement.style.zIndex = "auto";
    });
  },
  methods: {
    // 网址另开窗口
    windowOpen(url) {
      window.open(url);
    },
    CoverEmojiByUserType(userType) {
      return require(`@/assets/images/UserTypeEmoji/${userType}.png`);
    },
    /* 显示文字 */
    HandleShowRemark(remark, relatedUserName) {
      this.$alert(
        remark,
        `${relatedUserName ? relatedUserName : ""} 文字说明`,
        {
          closeOnClickModal: true,
          closeOnPressEscape: true,
          showConfirmButton: false,
        }
      ).catch(() => {});
    },
    // 取得凭证类型名称
    getMediaTypeLabels(type) {
      let typeLabels = [];
      type.split(",").forEach((res) => {
        let data = this.mediaTypeOptions.find(
          (item) => Number(res) === item.value
        );
        if (data) typeLabels.push(data.label);
      });
      return typeLabels.join(" + ");
    },
    HandleShowMedia(list, index, type) {
      // 加入支付审核所需要的数据
      if (list[index].fileType === "video") {
        this.needReviewOrderObj = list[index];
        this.needReviewOrderObj.accId = this.orderDetail.accId;
        this.needReviewOrderObj.bankNo = this.orderDetail.bankNo;
        this.needReviewOrderObj.withdrawPKOrderId = this.orderDetail.id; // 为了在收款审核能够展示从出款审核来的视频，传该出款订单 orderId 以便解析
      }

      this.showBankInfoDialog = true;
      this.showMediaObj = {
        visible: true,
        index: index,
        type: type,
        list,
      };
    },
    closeShowMediaDialog() {
      this.needReviewOrderObj = null;
      this.showBankInfoDialog = false;
      this.showMediaObj = {
        visible: false,
        index: null,
        type: null,
        list: [],
      };
    },
    HandlePopMediaObj(index, mediaList) {
      this.popMediaObj = {
        visible: true,
        index,
        mediaList,
      };
    },
    closePopMediaDialog() {
      this.popMediaObj = {
        visible: false,
        index: null,
        mediaList: [],
      };
    },
    getList() {
      this.dataListLoading = true;
      this.pageQuery.arbitrationApplyId = this.arbitrateOrderDetailObj.id;

      if (this.arbitrateOrderDetailObj.type === "pay") {
        arbitrateDetail(this.pageQuery)
          .then((res) => {
            this.total = res.data.total;
            this.dataList = res.data.list;
          })
          .finally(() => {
            this.dataListLoading = false;
          });
      } else if (this.arbitrateOrderDetailObj.type === "withdraw") {
        arbitrateWithdrawDetail(this.pageQuery)
          .then((res) => {
            this.total = res.data.total;
            this.dataList = res.data.list;
            this.dataDetail = res.data.dataDetail;
            this.fromPhoneList =
              res.data.referenceData.fromPhoneResult.fromPhoneList;
          })
          .finally(() => {
            this.dataListLoading = false;
          });
      }
    },
    // 给定预设日期、时间
    HandleDateDefault() {
      let startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      startDate.setHours(0, 0, 0, 0);

      let endDate = new Date();
      endDate.setHours(23, 59, 59, 999);

      this.date = [
        this.HandleDateYMDFormat(startDate),
        this.HandleDateYMDFormat(endDate),
      ];
      this.pageOrderQuery.startDate = this.date[0];
      this.pageOrderQuery.endDate = this.date[1];
    },
    // 切换订单分页
    handleClick(e) {
      if (this.logOrderActiveName !== e.name) {
        this.logOrderActiveName = e.name;
        if (e.name === "payOrder") {
          this.HandleGetOrderList("pay");
        } else {
          this.HandleGetOrderList("withdraw");
        }
      }
    },
    // 获取卡主历史订单
    HandleGetOrderList(type) {
      this.dataPayOrderList = [];
      this.dataWithdrawOrderList = [];
      this.HandleDateDefault();
      this.tableOrderLoading = true;
      this.pageOrderQuery.bankNo =
        this.arbitrateOrderDetailObj.resultFotArbitrate.bankNo;
      // this.pageOrderQuery.count = 5; // DSY-289 预设给 5 笔
      if (type && type === "pay") {
        getPayOrderListNoPage(this.ObjectClean(this.pageOrderQuery))
          .then((res) => {
            this.dataPayOrderList = res.data;
          })
          .catch(() => {
            this.$notify.error("服务器忙碌中，请稍后再试");
            this.dataPayOrderList = [];
            this.tableOrderLoading = false;
          })
          .finally(() => {
            this.tableOrderLoading = false;
          });
      } else {
        getWithdrawOrderListNoPage(this.ObjectClean(this.pageOrderQuery))
          .then((res) => {
            this.dataWithdrawOrderList = res.data;
          })
          .catch(() => {
            this.$notify.error("服务器忙碌中，请稍后再试");
            this.dataWithdrawOrderList = [];
            this.tableOrderLoading = false;
          })
          .finally(() => {
            this.tableOrderLoading = false;
          });
      }
    },
    // 找出补单状态对应文案
    HandleSupplementStatus(data) {
      const row = this.supplementStatusOptions.find(
        (item) => item.value === data
      );
      return row ? row.label : "-";
    },
    HandleReceiptOrderStatusClass(orderType, status) {
      if (status === 1) {
        return '<div style="color: #e6a23c;">处理中</div>';
      } else if (orderType === "pay" && status === 2) {
        return '<div style="color: #67C23A;">结案-卡主收款成功</div>';
      } else if (orderType === "pay" && status === 3) {
        return '<div style="color: #ff0000;">结案-卡主收款失败</div>';
      } else if (orderType === "withdraw" && status === 2) {
        return '<div style="color: #67C23A;">结案-卡主出款成功</div>';
      } else if (orderType === "withdraw" && status === 3) {
        return '<div style="color: #ff0000;">结案-卡主出款失败</div>';
      }
    },
    // 确认收款弹框
    HandleConfirmFinishCaseDialog(status) {
      this.finishCaseObj = {
        visible: true,
        loading: false,
        arbitrationApplyId: this.arbitrateOrderDetailObj.id,
        status,
        remark: null,
      };
      this.$nextTick(() => {
        this.$refs.finishRemark.$refs.input.focus();
      });
    },
    // 仲裁单进入待结案状态
    HandleArbitrationSpecial() {
      this.$confirm(`将此仲裁单转至待结案？`, "转至待结案", {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          if (this.arbitrateOrderDetailObj.type === "pay") {
            updatePayToSpecialType(this.arbitrateOrderDetailObj.id, {
              specialType: 1,
            })
              .then(() => {
                this.HandleEmitGetList();
                this.closeDialog();
              })
              .catch(() => {
                this.$notify.error("请稍后再试");
              });
          } else if (this.arbitrateOrderDetailObj.type === "withdraw") {
            updateWithdrawToSpecialType(this.arbitrateOrderDetailObj.id, {
              specialType: 1,
            })
              .then(() => {
                this.HandleEmitGetList();
                this.closeDialog();
              })
              .catch(() => {
                this.$notify.error("请稍后再试");
              });
          }
        })
        .catch(() => {});
    },
    // 确认收款保存
    HandleConfirmFinishCase() {
      this.finishCaseObj.loading = true;

      // 回单默认给信息
      if (
        this.arbitrationType !== "arbitrate" &&
        this.finishCaseObj.status === 2
      ) {
        this.finishCaseObj.remark = "已结案:确认到帐";
      }

      if (!this.finishCaseObj.remark) {
        this.$nextTick(() => {
          this.$refs.finishRemark.$refs.input.focus();
        });
        this.finishCaseObj.loading = false;
        this.$notify.error("结案原因或理由必填！");
        return;
      }
      if (this.arbitrateOrderDetailObj.type === "pay") {
        arbitrateFinishCase(this.finishCaseObj)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleEmitGetList();
            this.$store.dispatch("GetUnallocatedAll");
            this.closeDialog();
            this.HandleConfirmFinishCaseDialogClose();
            this.finishCaseObj.loading = false;
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.finishCaseObj.loading = false;
          });
      } else if (this.arbitrateOrderDetailObj.type === "withdraw") {
        arbitrateWithdrawFinishCase(this.finishCaseObj)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleEmitGetList();
            this.$store.dispatch("GetUnallocatedAll");
            this.closeDialog();
            this.HandleConfirmFinishCaseDialogClose();
            this.finishCaseObj.loading = false;
          })
          .catch(() => {
            this.$notify.error("请稍后再试");
            this.finishCaseObj.loading = false;
          });
      }
    },
    // 关闭确认弹框
    HandleConfirmFinishCaseDialogClose() {
      this.finishCaseObj = {
        visible: false,
        loading: false,
        arbitrationApplyId: null,
        status: null,
        remark: null,
      };
    },
    // 暂扣积分备注选项
    freezeObjOptionChange() {
      if (this.freezeObjOption === 1) {
        this.freezeObj.remark = "没有录制出款过程的视频";
      } else if (this.freezeObjOption === 2) {
        this.freezeObj.remark =
          "没有订单出款短信（补充提交短信视频给代理或者客服可以解除暂扣）";
      } else if (this.freezeObjOption === 3) {
        this.freezeObj.remark = null;
        this.$nextTick(() => {
          this.$refs.remark1.$refs.input.focus();
        });
      }
    },
    /* 结案但暂扣积分
     status 2 结案，确认出款
     freezeAmountTimeType 1 暂扣 2 永扣
    */
    HandleFreezeDialog(status, freezeAmountTimeType) {
      this.freezeObj = {
        visible: true,
        loading: false,
        arbitrationApplyId: this.arbitrateOrderDetailObj.id,
        status,
        freezeAmountTimeType,
        remark: null,
      };
      if (freezeAmountTimeType === 2) {
        this.freezeObjOption = 3;
        this.$nextTick(() => {
          this.$refs.remark2.$refs.input.focus();
        });
      }
    },
    // 送出暂扣
    HandleFreezeDialogSubmit() {
      this.freezeObj.loading = true;
      if (!this.freezeObjOption) {
        this.$notify.error("请选择暂扣原因！");
        return;
      }
      if (
        !this.freezeObj.remark ||
        (this.freezeObj.remark && this.freezeObj.remark.length < 2)
      ) {
        this.$notify.error("至少输入两个字作为备注！");
        return;
      }
      arbitrateWithdrawFinishCase(this.ObjectClean(this.freezeObj))
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleEmitGetList();
          this.$store.dispatch("GetUnallocatedAll");
          this.closeDialog();
          this.HandleFreezeDialogClose();
          this.freezeObj.loading = false;
        })
        .catch(() => {
          this.$notify.error("请稍后再试");
          this.freezeObj.loading = false;
        });
    },
    // 关闭暂扣弹框
    HandleFreezeDialogClose() {
      this.freezeObjOption = null;
      this.freezeObj = {
        visible: false,
        loading: false,
        arbitrationApplyId: null,
        status: null,
        freezeAmountTimeType: null,
        remark: null,
      };
    },
    closeDialog() {
      this.orderDetail = {}; // 清除订单详情数据
      this.arbitrationType = null;
      this.pageQuery.pageNum = 1;
      this.logOrderActiveName = "withdrawOrder";
      this.dataList = [];
      this.$emit("update:arbitrateOrderDetailObj", {});
      this.$emit("HandleGetList");
      this.smsHistoryDialogObj = {
        visible: false,
        username: "",
        userId: "",
      };
    },
    HandleEmitGetList() {
      this.getList();
      this.$emit("HandleGetList");
    },
    // 提交凭证
    HandleUploadDialog(patchStatus) {
      this.arbitrateUploadObj = this.HandleDeepCopy(
        this.arbitrateOrderDetailObj
      );
      if (patchStatus) {
        // 5: 需要卡主提交凭证(仲裁管理员)
        this.arbitrateUploadObj.patchStatus = patchStatus;
      }
      this.arbitrateUploadObj.visible = true;
      this.arbitrateUploadObj.uploading = false;
      this.arbitrateUploadObj.arbitrationType = this.arbitrationType; // 上传凭证元件判断使用
    },
    getBankLogo(bankCode) {
      try {
        return require(`@/assets/images/bankLogo/${bankCode}.png`);
      } catch (e) {
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAHnklEQVRoge2YfVBU1xmHn7u77C7fICAgIB8aPg1iQONCbMSm1kkkqWibSZw0mehobdpprGMz7cSETLRtplFik2iTSUw6ibRVYixmNMbaiLogIFStBBAU2OXLgKuyyOfuPf0D5Mtddtdxpu3MPn8wzD3nvu/vt+c9773nghs3bty4cfN/jDTVoDFS54lVfkUIsRqImmru/sAIdgfHcEXthSxNGXaMUCWEKUGrcFowIAPVwPNse/msyt4swQ+VBktzoQSPOor4UdBMXg1PdEUERKlght30U6EA7gf2AKl2rRtDjY85I75XoeQP02e7JkEj3a348cTDsBvbSHKuM1FO+gTRo3RRTKDStfm2qYOpDECWM1HKvQNdT+3rUs3bRkh6sGOgbUZ6MDDLmTjlXq4akO6NAUmUgh0DFqsqCwcdCuCWQsk3Wl/XEnsCHq7dYhNJlADYLF5JEjoBhJ3ehyo2ivb0HKwdXQQXvIVqVjQdD64AoNIrAIuzLfM2I7/+44nxHFy9CoAhq0y7uYc1B7/g+OUmZ6J8y9Ytl8HOCgjIVIaFoIqbyWD1JawdXUgeKjQL5jKgrxydd1f17zOccklcNBZZJnDbdjYeOcbMAD+eTk1xLoaQSm7/e4eBs6R7AOmarAwABk5WAKBOS0Hy8mSwtGrMgFcAABHBfjTv3cRzS+c5Tu5720AMFS3t3OwfQCkNXztjbHPOwEj9g40SCg2T5gnw0uiGxQyMCNZkpQPQr68k+C9/RBk9g898/ThaeZm12w+yeNMeGjuu80RmEm+s/R4hAd4cKq1jXf7fKX9nPWoPJUF+XuyqrORPFf8iZXoINZ1dFD6VS05CPIdq60kOCcKw+Wd03urFKgs2Hz3OrpxlzHn7fXblLEMI+OmhLwHsr4AsKTMB1OlzwGJlsPw8ANolOoYamkAItA8v4MLOvZjM/Wg9VCxfmEDx9jUkRAVT8OtVvL63mI++rCJHl8CCxEhS48JYl1+ERq1Co1KxJC4GSYKvG5vQN7ey/NO/ceCbWtZkpDHv3Q8J8vTi4tVOhqwySSHB/DgtlWfnpbJdXwYwRK9XpV0DkhA6AFVE2Mgvn4HvuqdQZ9xP377DaLPSQZb5x0UDsyOmoa828Lgukes9fSRGheCp8eCrsw0szZjN8aorZKfFcr2nj3aTGT9PDXpDC9mx0fQMDrLpyHHyS8o41tDIkrgYzhhbmeHrS5S/HyeamjHe7AYg/9FHePP0GS6broOQqsj/ZZ9dA4AOwPz2n7F2mQh6/7f4/GQ15t17Mb9XgDornaG6Rtrj4tB4qDh1sZnstFhOnG+kuukqtcZOzr/3Ak0dN3hx92Gy58Zy+mIzC5OikIWgxNDCd2fFcLLJwKDVOpr0RKOB9BnhHHh6JZIEJxqbaTObscgy3f2D/P7kaNmXjBc7oQcaI3URwmJtsWFqUplJpCUu5obShYaukCBD48TTZYxIPz/qN27gmcIiCqtrbl/+Edte3j8advwNYsjykDOB6zTerokH8JFcEg/w1mOPcLrZOF48eFhKx8+Z0IUkBTohHAcu85425XhqXBgV76yn4J8X0FcbOHG+kUsfv0ipoZW08FA8PVQ8//kXVLV1cO6FtZQaWokJ9Mdfq0EI2KEvo+nGTXIS4kl794NxAoWBvLwJFTJxBYRC51j+WP+3RWxYIJ+8tJKdn5dSa+zCZO4jd1EKdVev8WHVOXboyxiyyhTV1JObnEBlWzs/KNiPVcg8U1jExiPHqDeZiA+axqq/fkZNZ9f48CWT842ugDFS5yks1jRnDFRM8QIXFx6It1ZN7kPDT9XXPvma3KwkKtraUCkULIqJ4quGK5j6+liVkoQsBGfWP0eAVktrt5k9K5bjr9Vws3+A7LhoDtXWjwUXUunkfKMGhNUyHyS1I/HNai+uemjsjhs7u/n2Rg+n/t3MvuKLdHX38vHmFfQ2WVnll0ht5zW2FetJCgkmeXowKwoKWT03BVkGhSSxs7SclxZlsuHQEcpbJj2ZFfIdBkZLSAjJufJx8P6zff33yYiPICYsgGeXzmNFVjJ17dcobjQQ6KlFNzOCjIhwVqYk0m7uYfXcFHKTEzlQU0vK9BB+tUhHg8lEdIA/8sQN2YdSPj853+gKSBI6nNjAU9U/wJGKenw8NTy5dR8AJ3es4cCFWlCDqbefLceLqe28xmtLvsOpJiNHG66Qm5xIZWsHv9DNp7XbTHSAP/n68gnPCaCCvLzByfnGNrFgoWP5jg8wqbFhPJwaQ/UHPwcgNNCH3AeSaOk2Mz8ynGX3zSItPJSazi4kCV7NXkTT9ZvUb9xA5sxIcj7dR9+QhVey7+jod2xgGOnMxpAH7xNKccmR+C6VmgcSFzvjcwwNkKZ17R5bSOIJtm4pmnxZASArRaYzMVw/PgI+9+QAL7Aq79jAMGJAEji1gcv+Wwd4aOB3v+m0NaAY+etc/XtPvYFt4uvi+4Mtxh1gJjNsQAx/JHLEZY2P68m198AA7Lc3oAAQYvgjkSNmDdxyPXW/E715KoRUhMp62N7wsAGlYo0QnGP4w6ld3mypZk6/GaUrmq5YoHfKsPZoRhKvox56kry8uwrgxo0bN27c/M/zH+1GsKIeS8KEAAAAAElFTkSuQmCC";
      }
    },
    getCodePayOrderList() {
      getCodePayOrderList({
        id: this.arbitrateOrderDetailObj.orderId,
      })
        .then((res) => {
          this.orderDetail = res.data.list[0]; // 显示第一笔资料
        })
        .catch(() => {
          this.$notify.error("请稍后再试");
        });
    },
    // 取得支付订单详情
    getPayOrderDetailList() {
      getPayOrderDetailList({
        id: this.arbitrateOrderDetailObj.orderId,
      })
        .then((res) => {
          this.orderDetail = res.data.list[0]; // 显示第一笔资料
        })
        .catch(() => {
          this.$notify.error("请稍后再试");
        });
    },
    // 取得提现订单详情
    getWithdrawOrderDetailList(reloadNotify) {
      getWithdrawOrderDetailList({
        id: this.arbitrateOrderDetailObj.orderId,
      })
        .then((res) => {
          if (reloadNotify) this.$notify.success("刷新成功");
          this.orderDetail = res.data.list[0]; // 显示第一笔资料
        })
        .catch(() => {
          this.$notify.error("请稍后再试");
        });
    },
    HandleRotateVideo() {
      this.transformRotate += 90;
      document.querySelector(
        "video"
      ).style.transform = `rotate(${this.transformRotate}deg)`;
    },
    HandleSmsHistoryDialog() {
      this.smsHistoryDialogObj = {
        visible: true,
        username: this.arbitrateOrderDetailObj.payUsername,
        userId: this.arbitrateOrderDetailObj.payUserId,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.window-open {
  position: absolute;
  right: 5px;
  bottom: 5px;
  background-color: #fff;
  color: #409eff;
  font-size: 18px;
  z-index: 10;
  cursor: pointer;
}
.media-type-show-layout {
  font-size: 16px;
  position: absolute;
  padding: 3px 7px;
  left: 10px;
  top: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
}
.media-container {
  width: 180px;
  .media-list-container {
    width: 100%;
    text-align: center;
    position: relative;
    .media-type-list-container {
      position: absolute;
      left: -6px;
      top: -10px;
    }
    .media-type-block-container {
      width: 80px;
      height: 80px;
      line-height: 80px;
      border: 1px #eee solid;
      border-radius: 5px;
      padding: 10px 10px 0 10px;
      margin-bottom: 10px;
      .media-type-block-icon {
        font-size: 45px;
        &.photo {
          color: #b3d8ff;
        }
        &.video {
          color: #fbc4c4;
        }
      }
    }
  }
}

.order-status-layout {
  position: relative;
  text-align: center;
  font-weight: 500;
}
.order-status-title {
  position: absolute;
  left: 0;
  font-size: 17px;
  margin: 0;
}
.order-status {
  font-size: 20px;
  margin: 10px 0;
}

.el-carousel__item {
  border: 1px solid #ebebeb;
  background-color: #fff;
}

.el-carousel__item h3 {
  color: #475669;
  margin: 0;
  padding: 8px;
  text-align: center;
}
.fixed-detail {
  box-shadow: 0px 0px 1px 0px #666;
  margin-left: 10px;
  // table hover 会有 background
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: transparent;
  }
  .data-detail-list span {
    margin-bottom: 3px;
    margin-left: 0px;
    .high-line {
      font-size: 14px;
      font-weight: 600;
    }
  }
  .wrap-card-info {
    margin: 0;
    padding: 0;
  }
  .wrap-card-info li .trans-money {
    width: 100%;
    text-align: center;
    color: #766404;
    font-size: 24px;
    font-weight: 600;
  }
  .wrap-card-info li {
    margin: 0 auto 10px;
    padding: 10px;
    list-style-type: none;
    position: relative;
    width: 280px;
    display: block;
  }
  .card {
    color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    background-size: 100% auto;
    box-shadow: 2px 2px 6px 0px #000;
    overflow: hidden;
  }
  .from-card {
    background: radial-gradient(at center center, #1d7fac, #204178);
  }
  .to-card {
    background: linear-gradient(#2b3842, #3f4e5e, #2b3842);
  }
  .ic {
    width: 16px;
    border-radius: 5px;
    opacity: 0.6;
  }
  .card__logo {
    position: absolute;
    right: 5px;
    bottom: 5px;
    width: 36px;
  }

  .bank-name {
    font-size: 14px;
    font-weight: 600;
    position: relative;
    z-index: 20;
  }
  .bank-no {
    font-size: 18px;
    color: #f1da5f;
    font-weight: 600;
    text-shadow: 0 0 3px #000;
    position: relative;
    z-index: 0;
  }
  .from-card {
    .bank-name,
    .bank-no,
    .bank-card-name {
      opacity: 0.4;
      color: #fff;
    }
  }
  .bank-card-name {
    font-size: 16px;
    font-weight: 600;
    position: relative;
    z-index: 0;
    margin: 5px auto;
  }
  .union-pay {
    position: absolute;
    width: 30px;
    right: 6px;
    top: 6px;
  }
  .two-ball {
    position: absolute;
    position: absolute;
    right: 45px;
    bottom: 20px;
  }
  .two-ball span {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    border-radius: 50%;
    opacity: 0.3;
  }
  .two-ball span:nth-child(1) {
    right: 12px;
    background-color: #cd1f21;
  }
  .two-ball span:nth-child(2) {
    right: 0;
    background-color: #ef9713;
  }
  .d {
    position: absolute;
    font-size: 200px;
    font-weight: 600;
    opacity: 0.06;
    bottom: 30px;
  }

  .sms {
    line-height: 28px;
    letter-spacing: 1px;
    box-sizing: border-box;
    padding: 3px;
    border-radius: 3px;
    box-shadow: 0px 0px 4px 0px #888;
  }
}
.fixed-detail-dialog {
  background-color: #fff;
  position: fixed;
  right: 1vw;
  top: 2vh;
  z-index: 20000;
  padding: 10px 6px 2px;
  box-shadow: 0px 0px 5px 0px #666;
  border-radius: 10px;
}
</style>
<style>
.warning-title {
  color: #ff0000;
  font-weight: 600;
  font-size: 22px;
}
.warning-content {
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
.arbitrate-remark-tooltip {
  width: 300px !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}
/* 特殊加大 */
#arbitrate-order-detail .el-dialog__close,
#arbitrate-order-detail .el-icon-minus {
  color: #909399;
  font-size: 30px;
  font-weight: 600;
}
#arbitrate-order-detail .freeze-dialog .el-dialog__close,
#arbitrate-order-detail .freeze-dialog .el-icon-minus {
  color: #909399;
  font-size: 16px;
  font-weight: 400;
}
</style>

<style scoped>
#arbitrate-order-detail /deep/ .el-dialog {
  margin-bottom: 2vh;
}
.order-list {
  padding-top: 0;
}
.order-list /deep/ .el-table__body-wrapper td {
  padding: 2px 0;
}
.freeze-option {
  margin-top: 30px;
  padding: 0;
  list-style: none;
}
.freeze-option label {
  margin-bottom: 8px;
}
.freeze-option label /deep/ .el-radio__label {
  font-size: 16px;
}

#arbitrate-order-detail #zIndexObj-1,
#arbitrate-order-detail #zIndexObj-2,
#arbitrate-order-detail #zIndexObj-3 {
  position: relative;
}
#arbitrate-order-detail #zIndexObj-2:hover,
#arbitrate-order-detail #zIndexObj-3:hover {
  z-index: 99999;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/CommonArbitrateOrderDetail.vue